import React from 'react';
import classNames from 'classnames';
import styles from './paginator.module.scss';
import { Icon } from '../icon';

export interface PaginatorProps {
  current: number;
  total: number;
  pageSize?: number;
  onChange: (page: number) => void;
  className?: string;
}

export const Paginator: React.FC<PaginatorProps> = ({
  current,
  total,
  pageSize = 10,
  onChange,
  className
}) => {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  const handlePrev = () => {
    if (current > 1) onChange(current - 1);
  };

  const handleNext = () => {
    if (current < totalPages) onChange(current + 1);
  };

  const renderPages = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= current - 1 && i <= current + 1)) {
        pages.push(
          <button
            key={i}
            type="button"
            className={classNames(styles.pageButton, {
              [styles.isActive]: i === current
            })}
            onClick={() => onChange(i)}
          >
            {i}
          </button>
        );
      } else if (i === current - 2 || i === current + 2) {
        pages.push(<span key={i} className={styles.ellipsis}>...</span>);
      }
    }
    return pages;
  };

  return (
    <div className={classNames(styles.paginator, className)}>
      <button 
        type="button" 
        className={styles.pageButton} 
        disabled={current === 1}
        onClick={handlePrev}
      >
        <Icon name="angle-down" style={{ transform: 'rotate(90deg)' }} />
      </button>
      
      {renderPages()}
      
      <button 
        type="button" 
        className={styles.pageButton} 
        disabled={current === totalPages}
        onClick={handleNext}
      >
        <Icon name="angle-down" style={{ transform: 'rotate(-90deg)' }} />
      </button>
    </div>
  );
};
